var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUploadFileIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 24,
    viewBox: "0 0 20 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.5467 0.0888672H2.86403C1.53266 0.0888672 0.455463 1.14377 0.455463 2.4331L0.443359 21.1869C0.443359 22.4763 1.52056 23.5312 2.85193 23.5312H17.3881C18.7194 23.5312 19.8087 22.4763 19.8087 21.1869V7.12156L12.5467 0.0888672ZM14.9674 18.8427H5.28471V16.4985H14.9674V18.8427ZM14.9674 14.1543H5.28471V11.81H14.9674V14.1543ZM11.3364 8.29368V1.84704L17.9932 8.29368H11.3364Z",
    fill: "#007CA5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadFileIcon);
export default __webpack_public_path__ + "static/media/UploadFileIcon.5dc9b93a06f884112a580c3b593af962.svg";
export { ForwardRef as ReactComponent };